import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_EARNINGS_ACTION_TYPE } from '../actions/earnings.actions';

const initialState = null;

const earningsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_EARNINGS_ACTION_TYPE.SET_EARNINGS:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default earningsReducer;
